import { render } from "./DrugList.vue?vue&type=template&id=7efac0a3"
import script from "./DrugList.vue?vue&type=script&lang=js"
export * from "./DrugList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__